import React from 'react';
import { Helmet } from "react-helmet"
import { useTranslation } from 'react-i18next';
import { Route, Routes} from 'react-router-dom';
import Navbar from './componenents/navbar';
import Home from './pages/home/home';
import Footer from './componenents/footer';
import Sidebar from './componenents/sidebar';
import Contact from './componenents/contact';
import Cursor from './componenents/cursor';



function App() {
  const {t} = useTranslation()
  return (
    <>
      <Helmet>
        <title>{t('head.title')}</title>
      </Helmet>
      <Cursor/>
      <Contact/>
      <Sidebar/>
      <Navbar/>
      <Routes>
        <Route exact path='/' element={<Home/>}/>
      </Routes>
      <Footer/>
    </>
      
  );
}

export default App;
